<template>
  <div class="quickActions">
    <div class="mb-4">
      <h2>Quick Navigation</h2>
      <div class="form-group d-flex justify-content-between">
        <span class="col-4 label-text form-text mr-2">
          Search By
        </span>
        <select class="form-control"
                v-model="searchMode">
          <option value="instrumentId">Instrument ID</option>
          <option value="projectId">Project ID</option>
          <option value="projectName">Project Name</option>
          <option value="propertyId">Property ID</option>
          <option value="propertyName">Property Name</option>
          <option value="serviceId">Service ID</option>
        </select>
      </div>
      <GoToEntityForm v-if="searchMode.endsWith('Id')"
        :searchMode="searchMode"
      />
      <QuickSearch v-else
        :searchMode="searchMode"
      />
    </div>
    <div class="mb-4">
      <h2>Quick Lookup</h2>
      <SearchContactsModal
        modalId="'quickContactSearch'"
        :disableExisting="true"
        searchButtonText="Contact"
        :useArrowButton="true"
        @set-contact="setContact"
      />
    </div>
    <div
      v-if="!$store.getters['User/isCurrentUserViewOnly']"
      class="mb-4 d-none d-lg-block"
    >
      <h2>Quick Actions</h2>
      <ArrowButton destination="/project/new" label="Create New Project"></ArrowButton>
      <ArrowButton destination="/service/newMultiProperty"
        label="Create Multi-Property Service">
      </ArrowButton>
      <ArrowButton v-if="$store.getters['User/isCurrentUserAdmin']" destination="/instrumentTags" label="Manage Instrument Tags"></ArrowButton>
    </div>
  </div>
</template>

<script>
import ArrowButton from './ArrowButton.vue';
import GoToEntityForm from './GoToEntityForm.vue';
import QuickSearch from './QuickSearch.vue';
import SearchContactsModal from './contacts/SearchContactsModal.vue';

export default {
  name: 'QuickActions',
  components: {
    ArrowButton,
    GoToEntityForm,
    QuickSearch,
    SearchContactsModal,
  },
  data() {
    return {
      searchMode: 'projectId',
    };
  },
  methods: {
    setContact(contactResult) {
      this.$router.push({ name: 'contact', params: { id: contactResult.crmId } });
    },
  },
};
</script>
